import { useCallback, useEffect, useRef } from 'react';

export const useLatestRequestSignal = ({ abortOnUnmount = true } = {}) => {
  const controllerRef = useRef(null);

  const abort = useCallback(() => {
    controllerRef.current?.abort();
    controllerRef.current = null;
  }, []);

  const nextSignal = useCallback(() => {
    abort();
    controllerRef.current = new AbortController();
    return controllerRef.current.signal;
  }, [abort]);

  useEffect(() => (abortOnUnmount ? abort : undefined), [abort, abortOnUnmount]);

  return { nextSignal, abort };
};
